import { combineReducers } from 'redux';
import sidebar from './sidebar';
import agent from './agent'

const allReducers = combineReducers({   
    sidebar, agent
});

export default allReducers;
